import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';

export interface SubnavItem {
  text: string;
  href: string;
  onClick?: () => void;
}

@Component({
  selector: 'motn-subnav',
  templateUrl: './subnav.component.html',
  styleUrls: ['./subnav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    RouterLinkActive,
  ],
})
export class SubnavComponent implements OnInit {
  @Input() items: SubnavItem[] = [];
  @Input() activeItem: string = '';

  constructor() {
  }

  ngOnInit(): void {
  }

  onItemClick(item: SubnavItem, event: Event): void {
    if (item.onClick) {
      event.preventDefault();
      item.onClick();
    }
  }

  isActive(item: SubnavItem): boolean {
    return this.activeItem === item.href;
  }

}
